import React, {useEffect} from 'react';
import {reach} from '@hapi/hoek';
import marked from 'marked';
import ArticleImage from '../ArticleImage/ArticleImage';
import CardCarousel from '../CardCarousel/CardCarousel';
import NewsletterSignupWidget from '../NewsletterSignupWidget/NewsletterSignupWidget';
import ErrorBoundary from '../ErrorBoundary';
import {loadScript} from './load-script';

export const ArticleEmbed = ({block}) => {
    useEffect(() => {
        const matchedScript = block.embeddedContent.match(
            /<script.*?src="(.*?)"/,
        );

        if (matchedScript) {
            const scriptSrc = matchedScript[1];
            loadScript(scriptSrc);
        }
    }, [block]);

    // parse markdown string
    const markup = marked(block.embeddedContent);

    /* eslint-disable react/no-danger */
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: markup,
            }}
        />
    );
};

/* eslint-disable complexity */
export const EmbeddedEntry = ({block, inline, homeRoute, domain, ...rest}) => {
    const entry = block || inline;

    if (!entry) {
        return null;
    }

    switch (entry.__typename) {
        case 'NewsletterSignup':
            return <NewsletterSignupWidget {...block} homeRoute={homeRoute} />;
        case 'ExternalLinkCarousel':
            return (
                <CardCarousel
                    title={block.title}
                    cards={reach(block, 'externalLinksCollection.items')}
                    isInArticle
                    {...rest}
                />
            );
        case 'ArticleEmbed':
            return (
                <ErrorBoundary>
                    <ArticleEmbed block={block} />
                </ErrorBoundary>
            );
        case 'ArticleLink':
            // eslint-disable-next-line no-case-declarations
            const target = entry.uri.includes(domain) ? '_self' : '_blank';
            return (
                <a href={entry.uri} rel={entry.relationship} target={target}>
                    {entry.text}
                </a>
            );
        default:
            return <ArticleImage {...block} />;
    }
};
